/**
 * Validate the input for the Min and Max budget
 *
 * @name validateBudget
 *
 * @param {Function} callback - Callback function invoked with (err)
 */
function validateBudget(callback) {
	const budgetMin = Number(this.collect().get('budget_min'));
	const budgetMax = Number(this.collect().get('budget_max'));

	if ((budgetMin && budgetMax) && (budgetMin >= budgetMax)) {
		const publicError = new Error('Your maximum budget must be greater than your minimum budget.');
		callback([publicError]);
	} else {
		callback();
	}
}

export {
	validateBudget
}